import { useContext } from 'react';
import Context from './SessionContext';

export default () => useContext(Context);
